import { api } from './client'
import type { DesignConfig } from '@/types/design'

/** Fallback branding when `/design` is unreachable (dev / offline). */
export const DEFAULT_DESIGN: DesignConfig = {
  logos: {
    dark_logo: '/pwa-192x192.png',
    light_logo: '/pwa-192x192.png',
  },
  pwa: {
    title: 'Velox Terminal',
    description: 'Institutional multi-tenant trading terminal',
    icon_url: '/pwa-192x192.png',
  },
  favicon_url: '/favicon.svg',
}

export function fetchDesign(): Promise<DesignConfig> {
  return api.get<DesignConfig>('/design')
}
